import ListingSection from "../ListingSection/ListingSection";
import fetchStateAreas from "../SectionRegionElements/components/CountryStateSection/data/fetchStateAreas";
import wrapperHOC from "@Utils/wrapperHOC";
import styles from "../ListingSection/ListingSection.module.scss";
import useTranslationHook from "hooks/useTranslationHook";
import { useSelector, shallowEqual } from "react-redux";
import { AppState } from "@Store/index";

const AreasSectionWrapper = () => {
  const { t } = useTranslationHook();
  const { ssrAreas } = useSelector(
    ({ searchPageData }: AppState) => ({
      ssrAreas: searchPageData.listingData?.areas,
    }),
    shallowEqual,
  );

  return (
    <ListingSection
      title={t(
        "searchpage.components.sectionregionelements.components.countrystatesection.areassectiontitle",
      )}
      fetchFn={fetchStateAreas}
      type="area"
      loadingText="Loading areas..."
      className={styles.grayBackground}
      ssrData={ssrAreas}
    />
  );
};

export default wrapperHOC(AreasSectionWrapper, {
  componentName: "AreasSection-SearchPage",
  showForChina: true,
});
